<template>
	<section>
		<!-- 统计文字 -->
		<el-row class="statusRowWhite"  v-loading="isloading">
			<div class="RowChild">
				&nbsp;日期： &nbsp;
				<el-button type="primary" plain @click="changeDate(7)" id="yesterday">最近7天</el-button>
				<el-button type="primary" plain @click="changeDate(30)">最近30天</el-button>
			</div>
			<div class="RowChild">
				<el-date-picker class="xs24" v-model="dateVal" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="今天" format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd" :picker-options="pickerOptions"></el-date-picker>
			</div>
			<div class="RowChild">
				&nbsp;游戏来源： &nbsp;
				 <el-select class="xs24" v-model="pdata.source" placeholder="请选择" @change="getList">
	              <el-option label="全部" value=""></el-option>
	              <el-option label="内部游戏" value="内部游戏"></el-option>
	              <el-option label="外部游戏" value="外部游戏"></el-option>
	            </el-select>
            </div>
			<div class="RowChild">
				&nbsp;平台来源： &nbsp;
				<el-select class="xs24" v-model="pdata.platform_id" placeholder="请选择小游戏来源" @change="changePlatform" >
					<el-option :label="v.platform_name" :value="v.platform_id" v-for="(v,i) in get_issued_app_platform" :key="v.platform_id"></el-option>
				</el-select>
			</div>
			<div class="RowChild">
				&nbsp;小游戏名称： &nbsp;
				<searchApp class="xs24" @getid="changeId" :platform_id="pdata.platform_id.toString()" compare="issued" :pholder="pholder"></searchApp>
			</div>
			<div class="RowChild">
				&nbsp;用户操作： &nbsp;
				<el-button type="primary" @click="exportIncome">导出</el-button>
				<el-button type="primary" @click="fieldConfig">字段选择</el-button>
			</div>
			
		</el-row>

		<el-table :data="list" style="width: 100%;" stripe row-key="id"  show-summary :summary-method="getSummaries" v-if="list.length>0"  :height="height"  v-loading="isloading">

			<el-table-column prop="issued_app_name" label="发行名称" align="center" min-width="120px"></el-table-column>

			<el-table-column :prop="item.key" :label="item.name" align="center" v-for="item in showFieldList"  sortable :sort-method="(a,b)=>{return parseFloat(a[item.key]) - parseFloat(b[item.key])}">
				<template slot="header" slot-scope="scope">
					<el-tooltip class="item" effect="dark" :content="'截至'+pdata.edate+'的累计数据'" placement="top-start" v-if="item.key=='ltv'">
						<span>{{item.name}}<i class="el-icon-question"></i></span>
					</el-tooltip>
					<span v-else>{{item.name}}</span>
				</template>
				<template slot-scope="scope">
					<span :class="parseFloat(scope.row[item.key])>15?'red':''" v-if="item.key=='banner_click_per'">{{scope.row[item.key]}}</span>
					<span :class="scope.row.isTop10==true?'red':''" v-else-if="item.key=='total_day_contribution'">{{scope.row[item.key]}}</span>
					<span v-else-if="item.key=='origin_day_contribution'">
						<span v-if="scope.row.origin_day_contribution_trend==1" class="red">{{scope.row[item.key]}}</span>
						<span v-else-if="scope.row.origin_day_contribution_trend==-1" class="green">{{scope.row[item.key]}}</span>
						<span v-else>{{scope.row[item.key]}}</span>
					</span>
					<span  v-else-if="item.key=='jump_per'">
						<span v-if="scope.row.jump_per_trend==1" class="red">{{scope.row[item.key]}}</span>
						<span v-else-if="scope.row.jump_per_trend==-1" class="green">{{scope.row[item.key]}}</span>
						<span v-else >{{scope.row[item.key]}}</span>
					</span>
					
					
					<span v-else>{{scope.row[item.key]}}</span>
				</template>
				
			</el-table-column>
			<el-table-column label="操作" align="center">
				<template slot-scope="scope">
					<el-button size="mini" type="primary" @click="$router.push({'name':'产品日报详情',query:{name:scope.row.issued_app_name,sdate:pdata.sdate,edate:pdata.edate},'params':{issued_app_id:scope.row.issued_app_id}})">详情</el-button>
				</template>
			</el-table-column>
		</el-table>

		<!--<el-table  style="width: 100%;" stripe row-key="id"  v-if="list.length==0"></el-table>-->
		<div class="el-table el-table--fit el-table--striped el-table--enable-row-hover" style="width: 100%;" v-if="list.length==0">
			<div class="el-table__body-wrapper is-scrolling-none">
				<div class="el-table__empty-block" style="height: 100%; width: 100%"><span class="el-table__empty-text">暂无数据</span></div>
			</div>
		</div>

		<!--<el-pagination class="pagination" @size-change="SizeChange" @current-change="CurrentChange" :current-page.sync="pdata.page" :page-sizes="[20, 40, 60, 80]" :page-size="pdata.perpage" background layout="sizes, prev, pager, next, jumper" :total="pdata.perpage*maxPage"></el-pagination>-->

		<el-dialog title="编辑创意组合" :visible.sync="editDialog">
			<el-form :model="group"></el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="editDialog = false">取 消</el-button>
				<el-button type="primary" @click="editDialog = false">确 定</el-button>
			</div>
		</el-dialog>

		<el-dialog title="导出选择" :visible.sync="checkDialog">
			<el-row>
				<el-col :span="24" style="margin: 10px 0;">
					<el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
				</el-col>
			</el-row>
			<el-row>
				<el-checkbox-group v-model="checks" @change="handleCheckedChange">
					<el-row>
						<el-col :span="6" v-for="item in checklist" style="margin: 10px 0;">
							<el-checkbox :label="item" :key="item.value">{{item.name}}</el-checkbox>
						</el-col>
					</el-row>
				</el-checkbox-group>
			</el-row>
			<el-row>
				<el-col :span="24">
					<el-button type="primary" @click="handleDownload">确定</el-button>
				</el-col>
			</el-row>
		</el-dialog>

		<el-drawer title="我是标题" size="580px" :visible.sync="drawer" direction="rtl" :with-header="false">
			<el-tabs v-model="FieldIndex" type="card" @tab-click="fieldListChange">
			    <el-tab-pane label="按字段设置" name="0">
			    	<div class="filedFlex">
						<div class="fliedLeft">
							
							
							<div class="des">
								<span>可选字段</span><el-button type="success" @click="saveSelectField">确认并保存</el-button>
							</div>
							<div class="fliedBtns" v-for="(value,key) in fieldList">
								<div class="key">{{key}}</div>
								<div class="btnsbox">
		
									<el-button :type="item.isCheck?'primary':''" :plain="item.isCheck?false:true" size="mini" v-for="(item,index) in value" @click.native="fliedTap(key,index)" :autofocus="false">{{item.name}}</el-button>
		
								</div>
		
							</div>
							<div class="fliedFt">
								<el-button type="success" @click="saveSelectField">确认并保存</el-button>
							</div>
						</div>
						<div class="fliedRight">
							<div class="tit">已选字段</div>
							<draggable v-model="selectFieldList" :move="onMove" @start="isDragging=true" @end="isDragging=false">
								<transition-group type="transition" tag="ul">
									<li v-for="item in selectFieldList" :key="item.key" class="item">
										<i class="el-icon-rank"></i> {{item.name}}
										<i class="el-icon-close" @click="removeSelectField(item)"></i>
									</li>
								</transition-group>
							</draggable>
						</div>
					</div>
			    </el-tab-pane>
			    <el-tab-pane label="按模块设置" name="1">
			    	<div class="filedFlex">
						<div class="fliedLeft">
							
							
							<div class="des">
								<span>可选字段</span><el-button type="success" @click="saveSelectField">确认并保存</el-button>
							</div>
							<div class="fliedBtns" v-for="(value,key) in fieldList">
								<div class="key">{{key}}</div>
								<div class="btnsbox">
		
									<el-button :type="item.isCheck?'primary':''" :plain="item.isCheck?false:true" size="mini" v-for="(item,index) in value" @click.native="fliedTapForModel(key,index)" :autofocus="false">{{item.name}}</el-button>
		
								</div>
		
							</div>
							<div class="fliedFt">
								<el-button type="success" @click="saveSelectField">确认并保存</el-button>
							</div>
						</div>
						<div class="fliedRight">
							<div class="tit">已选字段</div>
							
							<div class="fliedModel" v-for="(value, key, index) in selectFieldListForModel" >
								<div class="fliedModelKey">{{key}}</div>
								<draggable v-model="selectFieldListForModel[key]" :move="onMove" @start="isDragging=true" @end="isDragging=false">
									<transition-group type="transition" tag="ul">
										<li v-for="item in value" :key="item.key" class="item">
											<i class="el-icon-rank"></i> {{item.name}}
											<i class="el-icon-close" @click="removeSelectFieldForModel(item,key)"></i>
										</li>
									</transition-group>
								</draggable>
							</div>
							
							
						</div>
					</div>
			    	
			    </el-tab-pane>
			 </el-tabs>
			
		</el-drawer>

	</section>
</template>

<script>
	import $ from "jquery";
	import { getProductDaily, getAppid, getfieldFilter, postfieldFilter, getValidProductPlatform } from "../../api/api";
	import draggable from 'vuedraggable'

	export default {
		name: 'productDaily',
		components: {
			draggable
		},
		data() {
			return {
				isloading:false,
				height:1500,
				chartColumn: null,
				pholder: "",
				pdata: {
					page: '1',
					perpage: '999',
					issued_app_id: "",
					kw: "",
					platform_id: 1,
					sdate: new Date(new Date().getTime() - 3600 * 1000 * 24)
						.toISOString()
						.slice(0, 10),
					edate: new Date(new Date().getTime() - 3600 * 1000 * 24)
						.toISOString()
						.slice(0, 10)
					// sdate: "2019-04-15",
					// edate: "2019-04-15",
				},
				tText: "请选择创意类型",
				plist: [],
				maxPage: 1,
				config: [],
				editDialog: false,
				checkDialog: false,
				issued_app_source: [],
				get_issued_app_platform: [],
				checklist: [{
						"name": "发行名称",
						"value": "issued_app_name"
					},
					{
						"name": "活跃用户",
						"value": "visit_uv"
					},
					{
						"name": "注册用户",
						"value": "visit_uv_new"
					},
					{
						"name": "分享率",
						"value": "share_per"
					},
					{
						"name": "裂变率",
						"value": "fission_rate"
					},
					{
						"name": "banner点击率",
						"value": "banner_click_per"
					},
					{
						"name": "流量主",
						"value": "origin_income"
					},
					{
						"name": "流量主arpu",
						"value": "origin_day_contribution"
					},
					{
						"name": "跳出率",
						"value": "jump_per"
					},
					{
						"name": "渠道卖量",
						"value": "channel_sell_income"
					},
					{
						"name": "矩阵卖量",
						"value": "matrix_sell_income"
					},
					{
						"name": "分发arpu",
						"value": "distribution_day_contribution"
					},
					{
						"name": "总arpu",
						"value": "total_day_contribution"
					},
					{
						"name": "广点通",
						"value": "gdt_buy_cost"
					},
					{
						"name": "渠道买量",
						"value": "channel_buy_cost"
					},
					{
						"name": "收入（含矩阵）",
						"value": "total_income_contain_matrix"
					},
					{
						"name": "利润",
						"value": "total_profit_contain_matrix"
					},
					{
						"name": "CP分成",
						"value": "total_profit_contain_matrix_cp"
					}
				],
				checks: [],
				isIndeterminate: false,
				checkAll: false,
				group: {},

				dateVal: [
					new Date(new Date().getTime() - 3600 * 1000 * 24 )
					.toISOString()
					.slice(0, 10),
					new Date(new Date().getTime() - 3600 * 1000 * 24)
					.toISOString()
					.slice(0, 10)
				],
				pickerOptions: {
					shortcuts: [{
							text: "昨天",
							onClick(picker) {
								const end = new Date();
								const start = new Date();
								start.setTime(start.getTime() - 3600 * 1000 * 24);
								picker.$emit("pick", [start, start]);
							}
						},
						{
							text: "最近一周",
							onClick(picker) {
								const end = new Date();
								const start = new Date();
								start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
								picker.$emit("pick", [start, end]);
							}
						},
						{
							text: "最近一个月",
							onClick(picker) {
								const end = new Date();
								const start = new Date();
								start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
								picker.$emit("pick", [start, end]);
							}
						},
						{
							text: "最近三个月",
							onClick(picker) {
								const end = new Date();
								const start = new Date();
								start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
								picker.$emit("pick", [start, end]);
							}
						}
					]
				},
				list: [], //所有数据
				drawer: false, //默认不展开

				fieldList: {
					'用户数据': [{
							"name": "活跃用户",
							"key": "visit_uv",
							"isCheck": false
						},
						{
							"name": "访问次数",
							"key": "visit_pv",
							"isCheck": false
						},
						{
							"name": "注册用户",
							"key": "visit_uv_new",
							"isCheck": false
						},
						{
							"name": "累计注册用户",
							"key": "visit_total",
							"isCheck": false
						},
						{
							"name": "新增用户占比",
							"key": "visit_uv_new_per",
							"isCheck": false
						},
						{
							"name": "人均访问次数",
							"key": "visit_uv_cnt",
							"isCheck": false
						},
						{
							"name": "人均停留时长",
							"key": "stay_time_uv",
							"isCheck": false
						},
						{
							"name": "次均停留时长",
							"key": "stay_time_avg",
							"isCheck": false
						}
					],
					'分享数据': [{
							"name": "分享次数",
							"key": "share_pv",
							"isCheck": false
						},
						{
							"name": "分享用户数",
							"key": "share_uv",
							"isCheck": false
						},
						{
							"name": "分享率",
							"key": "share_per",
							"isCheck": false
						},
						{
							"name": "会话新增",
							"key": "session_new",
							"isCheck": false
						},
						{
							"name": "裂变率",
							"key": "fission_rate",
							"isCheck": false
						},
						{
							"name": "分享用户人均分享次数",
							"key": "share_uv_cnt",
							"isCheck": false
						},
						{
							"name": "日活人均分享次数",
							"key": "share_visit_uv_cnt",
							"isCheck": false
						}
					],
					'流量主数据': [{
							"name": "banner人均曝光次数",
							"key": "banner_show_cnt",
							"isCheck": false
						},
						{
							"name": "banner点击率",
							"key": "banner_click_per",
							"isCheck": false
						},
						{
							"name": "视频人均曝光次数",
							"key": "video_show_cnt",
							"isCheck": false
						},
						{
							"name": "视频点击率",
							"key": "video_click_per",
							"isCheck": false
						},
						{
							"name": "千次曝光收入",
							"key": "ecpm",
							"isCheck": false
						},
						{
							"name": "流量主arpu",
							"key": "origin_day_contribution",
							"isCheck": false
						},
						{
							"name": "发行分成流量主收入",
							"key": "origin_divide_income",
							"isCheck": false
						},
						{
							"name": "分成后单日活贡献",
							"key": "origin_divide_day_contribution",
							"isCheck": false
						}
					],
					'分发数据': [

						{
							"name": "跳出率",
							"key": "jump_per",
							"isCheck": false
						},
						{
							"name": "换入活跃",
							"key": "huanliang_in",
							"isCheck": false
						},
						{
							"name": "换出活跃",
							"key": "huanliang_out",
							"isCheck": false
						},
						{
							"name": "分发收入（含矩阵）",
							"key": "distribution_income",
							"isCheck": false
						},
						{
							"name": "arpu（含矩阵）",
							"key": "distribution_day_contribution",
							"isCheck": false
						},
						{
							"name": "分发收入（不含矩阵）",
							"key": "nonmatrix_income",
							"isCheck": false
						},
						{
							"name": "arpu（不含矩阵）",
							"key": "nonmatrix_day_contribution",
							"isCheck": false
						},
						{
							"name": "总arpu",
							"key": "total_day_contribution",
							"isCheck": false
						}
					],
					'收支数据': [{
							"name": "LTV",
							"key": "ltv",
							"isCheck": false
						},
						{
							"name": "流量主",
							"key": "origin_income",
							"isCheck": false
						},
						{
							"name": "渠道卖量",
							"key": "channel_sell_income",
							"isCheck": false
						},
						{
							"name": "矩阵卖量",
							"key": "matrix_sell_income",
							"isCheck": false
						},
						{
							"name": "渠道买量",
							"key": "channel_buy_cost",
							"isCheck": false
						},
						{
							"name": "矩阵买量",
							"key": "matrix_buy_cost",
							"isCheck": false
						},
						{
							"name": "广点通",
							"key": "gdt_buy_cost",
							"isCheck": false
						},
						{
							"name": "CP分成",
							"key": "total_profit_contain_matrix_cp",
							"isCheck": false
						},
						{
							"name": "收入(含矩阵)",
							"key": "total_income_contain_matrix",
							"isCheck": false
						},
						{
							"name": "成本(含矩阵)",
							"key": "total_cost_contain_matrix",
							"isCheck": false
						},
						{
							"name": "利润(含矩阵)",
							"key": "total_profit_contain_matrix",
							"isCheck": false
						},
						{
							"name": "收入(不含矩阵)",
							"key": "total_income_no_matrix",
							"isCheck": false
						},
						{
							"name": "成本(不含矩阵)",
							"key": "total_cost_no_matrix",
							"isCheck": false
						},
						{
							"name": "利润(不含矩阵)",
							"key": "total_profit_no_matrix",
							"isCheck": false
						}
					]
				},
				selectFieldList: [],
				selectFieldListForModel:{
				'用户数据':[],
				'分享数据':[],
				'流量主数据':[],
				'分发数据':[],
				'收支数据':[]
				},
				showFieldList: [],
				FieldIndex:0,
			};
		},
		watch: {
			dateVal: {
				handler(n, o) {
					if(n[0]) {
						this.pdata.sdate = n[0];
						this.pdata.edate = n[1];
						this.getList();
					}
				},
				deep: true
			}
		},
		methods: {
			changePlatform(){
				this.$cookie.setCookie("platform_id",this.pdata.platform_id)
				this.getField();
			},
			fieldListChange(tab, event){
				var _this = this;
				console.log(tab.name);
				this.FieldIndex =tab.name;
				this.setFieldList()
			},
			setFieldList(){
				var _this = this;
				for(var key in _this.fieldList){
						_this.fieldList[key].forEach((v, i) => {
							v.isCheck = false;
						})
				}
				if(this.FieldIndex==0){
						this.selectFieldList.forEach((vv, ii) => {
							for(var key in _this.fieldList) {
								_this.fieldList[key].forEach((v, i) => {
									if(vv.key == v.key) {
										v.isCheck = true;
									}
								})
							}
						});
						this.showFieldList = JSON.parse(JSON.stringify(this.selectFieldList));
					}
					else if(this.FieldIndex==1){
						for(var key in this.selectFieldListForModel){
					
							this.selectFieldListForModel[key].forEach((vv,ii)=>{
								_this.fieldList[key].forEach((v, i) => {
										
									if(vv.key == v.key) {
				
										v.isCheck = true;
									}
								})
							})
						}
						var tempArr=[];
						for(var key in this.selectFieldListForModel){
							this.selectFieldListForModel[key].forEach((v,i)=>{
								tempArr.push(v)
							})
							
						}
						this.showFieldList = JSON.parse(JSON.stringify(tempArr));
					}
					this.getList();
			},
			async getSelectField() {
				var _this = this;
				var p = "position=product_daily_index";
				const data = await getValidProductPlatform(p, this.$cookie.getCookie("login"))
				if(data.code == 200) {
					if(!this.$cookie.getCookie("platform_id")){
						this.pdata.platform_id = data.data[0].platform_id;
					}
					
					this.get_issued_app_platform = data.data;
				}

				this.getField();
			},
			getField() {
				console.log(this.pdata.platform_id)
				var _this = this;
				var p = "position=product_daily_index";
				getfieldFilter(p, this.$cookie.getCookie("login")).then(res => {
					
					this.FieldIndex = res.data.content.FieldIndex;
					
					console.log(res.data.content);
					if(res.data.content.FieldList == null || res.data.content.FieldList.length == 0) {
						if(this.pdata.platform_id == 1) {
							//微信 	发行名称 所属平台 活跃用户 注册用户 次日留存 banner点击率 流量主arpu 跳出率 LTV 当日回收
							res.data.content.FieldList = ['visit_uv', 'visit_uv_new', 'retain_day1', 'banner_click_per', 'origin_day_contribution', 'jump_per', 'ltv'];
						} else if(this.pdata.platform_id == 2) {
							//头条 累计访问人数 活跃用户 注册用户 次日留存 流量主arpu 停留时长 人均访问次数 录屏率  LTV 总利润
							res.data.content.FieldList = ['visit_uv_totle', 'visit_uv', 'visit_uv_new', 'retain_day1', 'origin_day_contribution', 'stay_time_uv', 'visit_uv_cnt', 'click_screen_record_rate', 'ltv'];
						} else {
							//手Q 累计访问人数 活跃用户 注册用户 次日留存 流量主arpu 停留时长 人均访问次数  LTV 总利润
							res.data.content.FieldList = ['visit_uv_totle', 'visit_uv', 'visit_uv_new', 'retain_day1', 'origin_day_contribution', 'stay_time_uv', 'visit_uv_cnt', 'ltv'];
						}
					}
					
					
					_this.selectFieldList = [];
					_this.selectFieldListForModel =  {
								'用户数据':[],
								'分享数据':[],
								'流量主数据':[],
								'分发数据':[],
								'收支数据':[]
								};
					_this.showFieldList = [];
					_this.list = [];
//					for(var key in _this.fieldList){
//						_this.fieldList[key].forEach((v, i) => {
//								v.isCheck = false;
//						})
//					}
					
					res.data.content.FieldList.forEach((vv, ii) => {
						for(var key in _this.fieldList) {
							_this.fieldList[key].forEach((v, i) => {
								if(vv == v.key) {
									v.isCheck = true;
									_this.selectFieldList.push(v);
								}
							})
						}
					});
					for(var key in res.data.content.FieldListForModel){
						res.data.content.FieldListForModel[key].forEach((vv,ii)=>{
							_this.fieldList[key].forEach((v, i) => {
								
								if(vv == v.key) {
									v.isCheck = true;
									_this.selectFieldListForModel[key].push(v);
								}
							})
						})
					}
					
					if(this.FieldIndex==0){
						this.showFieldList = JSON.parse(JSON.stringify(this.selectFieldList));
					}
					else if(this.FieldIndex==1){
						var tempArr=[];
						for(var key in this.selectFieldListForModel){
					
							this.selectFieldListForModel[key].forEach((v,i)=>{
								tempArr.push(v)
							})
							
						}
						this.showFieldList = JSON.parse(JSON.stringify(tempArr));
					}
					this.getList();
				})
			},
			saveSelectField() {
				var tempArr = [];
				var tempArrModel={
				'用户数据':[],
				'分享数据':[],
				'流量主数据':[],
				'分发数据':[],
				'收支数据':[]
				};
				this.selectFieldList.forEach((v, i) => {
					tempArr.push(v.key);
				})
			
				for(var key in this.selectFieldListForModel){
						
					this.selectFieldListForModel[key].forEach((v,i)=>{
						tempArrModel[key].push(v.key)
					})
				}
				var content = {
					FieldIndex: this.FieldIndex,
					FieldList:tempArr,
					FieldListForModel:tempArrModel,
				}
				
				var p = {
					position: 'product_daily_index',
					content: content,
				}
				postfieldFilter(p, this.$cookie.getCookie("login")).then(res => {
					this.drawer = false;
					this.showFieldList = JSON.parse(JSON.stringify(this.selectFieldList));
					this.getField();

				})
			},
			removeSelectField(obj) {
				this.removeArrForObjName(this.selectFieldList, obj);

				for(let key in this.fieldList) {
					this.fieldList[key].some((item, index) => {
						if(item.name == obj.name) {
		
							this.fieldList[key][index].isCheck = false;

						}
					})
				}

			},
			removeSelectFieldForModel(obj,key){
		
				var _this =this;
				this.removeArrForArrObjName(this.selectFieldListForModel, obj,key);
				
				
				this.fieldList[key].some((item, index) => {
					if(item.name == obj.name) {
	
						this.fieldList[key][index].isCheck = false;

					}
				})
				

				
			},
			onMove({
				relatedContext,
				draggedContext
			}) {
				const relatedElement = relatedContext.item;
				const draggedElement = draggedContext.item;
			},
			fieldConfig() {
				this.drawer = true;
				this.setFieldList();
				
			},
			fliedTap(key, index) {

				this.fieldList[key][index].isCheck = !this.fieldList[key][index].isCheck;
				var result = this.selectFieldList.some(item => {
					if(item.name == this.fieldList[key][index].name) {
						return true
					}
				})
				if(this.fieldList[key][index].isCheck) {
					if(!result) {
						this.selectFieldList.push(this.fieldList[key][index])
					}
				} else {
					if(result) {
						this.removeArrForObjName(this.selectFieldList, this.fieldList[key][index])
					}
				}
			},
			fliedTapForModel(key, index) {
				
				this.fieldList[key][index].isCheck = !this.fieldList[key][index].isCheck;
				var result
				for(var key2 in this.selectFieldListForModel){
					result = this.selectFieldListForModel[key2].some(item => {
						if(item.name == this.fieldList[key][index].name) {
							
							return true;
							

						}
					})
					if(result){
						break;
					}
					
				}
	
				if(this.fieldList[key][index].isCheck) {
					if(!result) {
						this.selectFieldListForModel[key].push(this.fieldList[key][index])
					}
				} else {
					if(result) {
				
						this.removeArrForArrObjName(this.selectFieldListForModel, this.fieldList[key][index],key)
					}
				}
			},
			removeArrForObjName(_arr, _obj) {
				var length = _arr.length;
				for(var i = 0; i < length; i++) {
					if(_arr[i].name == _obj.name) {
						_arr.splice(i, 1); //删除下标为i的元素
						return _arr;
					}
				}
			},
			removeArrForArrObjName(obj,_obj,key,){
				console.log(obj)
				var length = obj[key].length;
				for(var i = 0; i < length; i++) {
					if(obj[key][i].name == _obj.name) {
						obj[key].splice(i, 1); //删除下标为i的元素
						console.log(obj)
						return obj;
					}
				}
				
				
				
			},
			handleCheckAllChange(val) {
				this.checks = val ? this.checklist : [];
				this.isIndeterminate = false;
			},
			handleCheckedChange(value) {

				let checkedCount = value.length;
				this.checkAll = checkedCount === this.checklist.length;
				this.isIndeterminate = checkedCount > 0 && checkedCount < this.checklist.length;
				this.checks = value;
			},
			exportIncome() {
				if(this.loading == true) {
					this.$message({
						message: "暂时无法导出，请稍后！",
						type: "warning"
					});
					return false;
				} else {
					this.checkDialog = true
				}
			},
			//数据导出
			handleDownload() {
				var that = this;
				var arr = [];
				var arrHd = this.checks.map((v, i) => {
					return v.name
				})
				var arrFval = this.checks.map((v, i) => {
					return v.value
				})
				//    if (that.tablelistAll.length > 0) {
				//      that.exclelist = arr.concat(that.tablelistAll);
				//    } else {
				//      that.exclelist = arr.concat(that.tablelist);
				//      arrHd = arrHd.splice(1);
				//      arrFval = arrFval.splice(1);
				//    }

				if(that.List == "") {
					return false;
				}

				console.log(arrHd);
				console.log(arrFval);
				require.ensure([], () => {
					const {
						export_json_to_excel,
						export_table_to_excel
					} = require("../../vendor/Export2Excel.js");
					const tHeader = arrHd;
					const filterVal = arrFval;
					const list = this.list;

					const data = this.formatJson(filterVal, list);

					export_json_to_excel(
						tHeader,
						data,
						this.pdata.sdate + '~' + this.pdata.edate + "产品日报"
					);
					//      export_table_to_excel("ta");
				});
			},
			formatJson(filterVal, jsonData) {
				return jsonData.map(v => filterVal.map(j => v[j]));
			},
			changeDate(s) {
				this.dateVal = [
					new Date(new Date().getTime() - 3600 * 1000 * 24 * s)
					.toISOString()
					.slice(0, 10),
					new Date(new Date().getTime() - 3600 * 1000 * 24 * s)
					.toISOString()
					.slice(0, 10)
				];
				// this.getList();
			},
			getSummaries(param) {
				var columnIdx=['distribution_income','nonmatrix_income','nonmatrix_day_contribution','origin_income','channel_sell_income', 'matrix_sell_income', 'channel_buy_cost', 'matrix_buy_cost', 'gdt_buy_cost', 'total_profit_contain_matrix_cp', 'total_income_contain_matrix', 'total_cost_contain_matrix', 'total_profit_contain_matrix', 'total_income_no_matrix', 'total_cost_no_matrix', 'total_profit_no_matrix'];
				const {
					columns,
					data
				} = param;
				const sums = [];
		        columns.forEach((column, index) => {
		        
		          if(columnIdx.indexOf(column.property)==-1){
		          	 sums[index] = '-';
		          	  return;
		          }
		          
		          const values = data.map(item => Number(item[column.property]));
		          if (!values.every(value => isNaN(value))) {
		            sums[index] = values.reduce((prev, curr) => {
		              const value = Number(curr);
		              if (!isNaN(value)) {
		                return prev + curr;
		              } else {
		                return prev;
		              }
		            }, 0);
		            sums[index] = sums[index].toFixed(2)+' 元';
		          } else {
		            sums[index] = 'N/A';
		          }
		        });
		
		        return sums;
			},
			getConfig() {
				if(this.$store.config) {

					this.issued_app_source = this.$store.config.issued_app_source; //游戏来源

					// this.game_miniprogram_account.unshift('无');
				} else {
					setTimeout(() => {
						this.getConfig();
					}, 50);
				}
			},
			getList() {
				this.isloading = true;
				var p = "";
				for(var k in this.pdata) {
					// if (this.pdata[k]) p += "&" + k + "=" + this.pdata[k];
					if(this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
				}
				getProductDaily(p, this.$cookie.getCookie("login")).then(res => {
					this.isloading = false;
					if(res.code == 200) {
						// "总访问人数", "总新增访问人数", "总收入","利润","买量成本","ROI"
						if(res.data.list && res.data.list.length > 0) {
							
							this.list = res.data.list;
							this.list2 =this.arrSort(JSON.parse(JSON.stringify(res.data.list)),'total_day_contribution');
							
							this.list2 = this.list2.slice(0,10);
							console.log(this.list2)
							this.list2.forEach((v,i)=>{
								for(var j=0;j<this.list.length;j++){
									if(this.list[j].issued_app_id==v.issued_app_id){
										this.list[j].isTop10=true;
										break;
									}
								}
							})
							this.maxPage = parseInt( res.data.count / this.pdata.perpage )+1;
						} else {
							this.list = [];
							this.maxPage = 1;
						}

					}
				});
			},
			arrSort(arr,str){
				return arr.sort(function(a, b){return b[str] - a[str]}); 
			},
			SizeChange(v) {
				this.pdata.perpage = v;
				this.getList();
			},
			CurrentChange(v) {
				this.pdata.page = v;
				this.getList();
			},
			changeDate(s) {
				this.dateVal = [
					new Date(new Date().getTime() - 3600 * 1000 * 24 * s)
					.toISOString()
					.slice(0, 10),
					new Date(new Date().getTime() - 3600 * 1000 * 24)
					.toISOString()
					.slice(0, 10)
				];
				// this.getList();
			},
			changeId(res) {
				this.pdata.issued_app_id = res;
				this.getList();
			}
		},

		created() {
			
			this.height = window.innerHeight;
//			this.height = $(window).height() - 320
		},

		mounted() {
			var _this = this;
			$(".content-container").scroll(function() {
			 console.log($(".content-container").scrollTop());
			 if($(".content-container").scrollTop()>150){
				
			 	_this.height = window.innerHeight-154;
//			 	_this.$forceUpdate();
			 }
//			 else{
//			 	_this.height = window.innerHeight;
//			 }
			});

			if(Object.keys(this.$route.params).length > 0) {
				this.pdata.sdate = this.$route.params.sdate;
				this.pdata.edate = this.$route.params.edate;
				this.pdata.app_id = this.$route.params.app_id;
				this.pholder = this.$route.params.name;
			}
			if(this.$cookie.getCookie("platform_id")){
				this.pdata.platform_id = parseInt(this.$cookie.getCookie("platform_id")) 
			}

			this.getConfig();
			this.getSelectField();
			console.log(this.$options)
			
		}
	};
</script>

<style lang="scss">
	.el-button+.el-button {
		margin-left: 0;
	}
	
	#chart>div {
		margin: 0 auto;
	}
</style>

<style scoped="scoped" lang="scss">
	.red {
		color: #FF0000;
	}
	
	.green{
		color: #11B95C;
	}
	
	.filedFlex {
		width: 100%;
		display: flex;
		flex-direction: row;
		align-items: flex-start;
		justify-content: flex-start;
		height: 100%;
	}
	
	.fliedLeft {
		width: 360px;
		border-right: 1px solid #E6E6E6;
		box-sizing: border-box;
		height: 100%;
		height:calc(100vh - 70px);
		overflow-y: auto;
	}
	
	.fliedRight {
		width: 220px;
		height: 100%;
		height: 100vh;
		overflow-y: auto;
	}
	
	.tit {
		padding: 0 10px;
		text-align: left;
		height: 50px;
		line-height: 50px;
		font-size: 16px;
		border-bottom: 1px solid #E6E6E6;
	}
	
	.filedFlex .des {
		padding: 0 15px;
		font-size: 14px;
		height: 40px;
		line-height: 40px;
		margin: 10px 0;
		span{
			
		}
		button{
			float: right;
		}
	}
	
	.filedFlex .key {
		padding: 0 15px;
		font-size: 14px;
		height: 50px;
		line-height: 50px;
		font-weight: bold;
	}
	
	.btnsbox {
		display: flex;
		flex-direction: row;
		align-items: flex-start;
		justify-content: flex-start;
		flex-wrap: wrap;
		padding: 5px;
	}
	
	.btnsbox button {
		margin: 5px;
	}
	
	.btnsbox button:focus {}
	
	.fliedRight ul {
		margin: 0;
		padding: 0;
	}
	
	.fliedRight ul li {
		line-height: 40px;
		list-style: none;
		border-bottom: 1px solid #E6E6E6;
		padding: 0 10px;
	}
	
	.fliedRight ul li i {
		margin-right: 5px;
	}
	
	.fliedRight ul li i.el-icon-close {
		float: right;
		cursor: pointer;
		margin-top: 15px;
	}
	
	.fliedFt {
		margin: 20px 0;
		padding: 0 10px;
	}
	.fliedModel{
		border-bottom: 2px solid #20A0FF;
	}
	.fliedModelKey{
		padding: 10px;
		font-size: 18px;
		font-weight:bold ;
	}
</style>


// WEBPACK FOOTER //
// productDaily.vue?e50c72ec